import Translations from '../Translations';
import React, {
    useState,
    useEffect,
} from 'react';
import {
    Dimmer,
    Loader,
    Grid,
    Header,
} from 'semantic-ui-react';
import * as LottiePlayer from "@lottiefiles/lottie-player";

import loaderAnimationFile from '../../assets/new_loader.json';

const LoadTimer = (props) => {

    const {
        animate,
        countdown,
        handleTimeup,
    } = props;

    const [counter, setCounter] = useState(3);

    useEffect(() => {
        if (countdown && handleTimeup) {
            // console.log('---> Setup Counter!');
            const timer = setTimeout(() => {
                setCounter(counter - 1);
                // console.log('---> Trigger Counter!', counter);
                if (counter === 0) handleTimeup();
            }, 1000);
            return () => clearTimeout(timer);
        }
    });

    if (!animate) {
        return (
            <Dimmer active inverted>
                <Loader inverted><Translations text="common.loading" backup={"Loading"} /></Loader>
            </Dimmer>
        );
    }

    return (
        <Grid container columns={1}>
            <Grid.Column>
                &nbsp;
            </Grid.Column>
            <Grid.Column>
                <lottie-player
                    autoplay
                    loop
                    mode="normal"
                    speed={1}
                    src={JSON.stringify(loaderAnimationFile)}
                    // src="https://assets6.lottiefiles.com/packages/lf20_mdbdc5l7.json"
                />
            </Grid.Column>
            <Grid.Column>
                <Header textAlign="center"><Translations text="selection.preparing_experience" backup={"Please wait while we customize your selection experience"} /></Header>
            </Grid.Column>
        </Grid>
    );
};

export default LoadTimer;